module.exports = __webpack_public_path__ + "static/img/404@2x.912439b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404@2x.png
// module id = vadO
// module chunks = 1